// extracted by mini-css-extract-plugin
export default {"editor":"editor_editor__jCw0L","link":"editor_link__u+Lk3"};